import { accessOf, billingText, planOf, roDate, type Company, t } from '@procumi/shared';
import { rich } from '../lib/rich';

/**
 * Banda de sus: cât mai ține proba, sau că firma n-are încă pachet. Firmele cu pachet și
 * cele de dinainte de pachete nu o văd deloc.
 */
export function PlanBanner({
  company,
  onChoose,
}: {
  company: Company;
  /** lipsă: nu ești administrator, deci nu alegi tu pachetul */
  onChoose?: () => void;
}) {
  const access = accessOf(company);
  if (company.subscription?.status === 'past_due') {
    return (
      <div className="plan-banner over" role="status">
        <span>
          {rich(
            '<b>Plata cu cardul n-a trecut.</b> Stripe mai încearcă câteva zile; schimbă cardul din „Contul firmei → Pachet”, ca pachetul să nu se oprească.',
          )}
        </span>
      </div>
    );
  }
  if (access.state === 'legacy' || access.state === 'active') return null;

  const req = company.planRequest;
  const asked = req ? (
    <>
      {rich(
        'Ai cerut pachetul <b>{0}</b>, {1}, pe {2}. {3}',
        planOf(req.plan)?.name,
        billingText(req.billing),
        roDate(req.at.slice(0, 10)),
        company.cardPayments
          ? t(
              'Îți trimitem factura pe email{0}',
              access.state === 'readonly' ? t('; contul se deschide când primim plata.') : '.',
            )
          : t('Te contactăm în curând.'),
      )}
    </>
  ) : null;

  if (access.state === 'trial') {
    const days = access.trialDaysLeft!;
    return (
      <div className="plan-banner" role="status">
        <span>
          {asked ?? (
            <>{rich('Probă gratuită: mai ai <b>{0}</b>.', days === 1 ? t('o zi') : t('{0} zile', days))}</>
          )}
        </span>
        {onChoose ? (
          <button className="btn small" type="button" onClick={onChoose}>
            {req ? t('Schimbă cererea') : t('Alege pachetul')}
          </button>
        ) : null}
      </div>
    );
  }

  return (
    <div className="plan-banner over" role="status">
      <span>
        {asked ?? (
          <>
            <b>{t('Contul nu are încă un pachet.')}</b>{' '}
            {t(
              'Vezi tot, dar ca să creezi sau să schimbi ceva {0}',
              onChoose
                ? t('alege un pachet.')
                : t('un administrator al contului trebuie să aleagă un pachet.'),
            )}
          </>
        )}
      </span>
      {onChoose ? (
        <button className="btn small primary" type="button" onClick={onChoose}>
          {req ? t('Schimbă cererea') : t('Alege pachetul')}
        </button>
      ) : null}
    </div>
  );
}
